import React, { useState, useContext, useRef } from "react";
import { PhotoManagerContext } from "..";
import { RenameModalProps } from "../types";
import toastr from "../../../common/toastr";
import {
  validateName,
  restrictedTermsError
} from "../../../../utils/validateName";
import { usePopupClickOutside } from "../../../../hooks/usePopupClickOutside";

const Rename: React.FC<RenameModalProps> = ({
  onClose,
  folder,
  onReNameClicked
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [name, setName] = useState<string>(folder?.name || "");
  const [loading, setLoading] = useState<boolean>(false);
  const context = useContext(PhotoManagerContext);

  usePopupClickOutside(popupRef, () => onClose());

  const handleRename = async () => {
    const isValidName = validateName(name);
    if (!isValidName) {
      toastr.error(restrictedTermsError);
      return;
    } else if (!name.trim()) {
      toastr.error("Please enter a valid name");
      return;
    }
    setLoading(true);
    try {
      if (folder) await onReNameClicked(folder, name);
      onClose();
    } catch (error) {
      console.error(`Error renaming folder`, error);
      toastr.error("Failed to rename folder. Please try again");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleRename();
    }
  };

  return (
    <div>
      <div
        id="filter-dialog"
        className="modal fade in geo-modal geo-modal--small"
        role="dialog"
      >
        <div
          className="modal-dialog filter-dialog-content rename-folder-modal"
          ref={popupRef}
        >
          <div className="geo-modal__header renaming-header">
            <div className="primary">Renaming</div>
            <div className="secondary">{folder?.name}</div>
          </div>
          <button
            type="button"
            className="close"
            onClick={onClose}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="modal-content">
            <div className="geo-form geo-form--fw rename-input">
              <input
                id="name-input"
                type="text"
                className="geo-form__input ws-geo-input"
                value={name}
                onChange={e => {
                  e.stopPropagation();
                  setName(e.target.value);
                }}
                onKeyPress={handleKeyPress}
                placeholder={`Enter folder name`}
                autoFocus
                disabled={loading}
              />
            </div>
            <div className="modal-footer geo-modal__actions dont-break ws-delete-footer-btns">
              <button
                className="geo-btn geo-btn--secondary geo-btn--caps geo-btn--small rename-btn"
                onClick={handleRename}
                disabled={loading || !name.trim()}
              >
                {loading ? (
                  <div className="loading-spinner">
                    Renaming... <span className="fa fa-spinner fa-spin"></span>
                  </div>
                ) : (
                  "RENAME"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default Rename;
